/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PatchAIConfigVariationRequest = {
  projectKey: string;
  configKey: string;
  variationKey: string;
  /**
   * AI Config variation object to update
   */
  aiConfigVariationPatch?: components.AIConfigVariationPatch | undefined;
};

/** @internal */
export const PatchAIConfigVariationRequest$inboundSchema: z.ZodType<
  PatchAIConfigVariationRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
  variationKey: z.string(),
  AIConfigVariationPatch: components.AIConfigVariationPatch$inboundSchema
    .optional(),
}).transform((v) => {
  return remap$(v, {
    "AIConfigVariationPatch": "aiConfigVariationPatch",
  });
});
/** @internal */
export type PatchAIConfigVariationRequest$Outbound = {
  projectKey: string;
  configKey: string;
  variationKey: string;
  AIConfigVariationPatch?:
    | components.AIConfigVariationPatch$Outbound
    | undefined;
};

/** @internal */
export const PatchAIConfigVariationRequest$outboundSchema: z.ZodType<
  PatchAIConfigVariationRequest$Outbound,
  z.ZodTypeDef,
  PatchAIConfigVariationRequest
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
  variationKey: z.string(),
  aiConfigVariationPatch: components.AIConfigVariationPatch$outboundSchema
    .optional(),
}).transform((v) => {
  return remap$(v, {
    aiConfigVariationPatch: "AIConfigVariationPatch",
  });
});

export function patchAIConfigVariationRequestToJSON(
  patchAIConfigVariationRequest: PatchAIConfigVariationRequest,
): string {
  return JSON.stringify(
    PatchAIConfigVariationRequest$outboundSchema.parse(
      patchAIConfigVariationRequest,
    ),
  );
}
export function patchAIConfigVariationRequestFromJSON(
  jsonString: string,
): SafeParseResult<PatchAIConfigVariationRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PatchAIConfigVariationRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PatchAIConfigVariationRequest' from JSON`,
  );
}
